var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 207,
    height: 140,
    fill: "none",
    viewBox: "0 0 207 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103.017,
    cy: 70,
    r: 70,
    fill: "#495E57"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4CE14",
    d: "M55.9146 81.5599C61.3335 85.6776 63.4088 86.2376 67.9464 92.4223C75.3582 102.543 74.2793 106.727 76.4782 108.654C78.677 110.581 88.7652 112.138 95.6417 103.334C102.518 94.5305 113.249 70.2034 127.002 55.6517C140.755 41.0999 147.178 36.8587 151.304 34.6517C155.43 32.4446 142.352 32.9223 116.642 53.3623C98.7629 67.5764 86.1052 87.2011 86.1052 87.2011C86.1052 87.2011 82.5311 76.4952 74.5758 69.314C66.6205 62.1329 46.9052 74.7493 55.9146 81.5599Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4CE14",
    fillRule: "evenodd",
    d: "M0.0761719 70C0.0761719 69.0904 0.725303 68.353 1.52605 68.353H19.2145C20.0153 68.353 20.6644 69.0904 20.6644 70C20.6644 70.9097 20.0153 71.6471 19.2145 71.6471H1.52605C0.725303 71.6471 0.0761719 70.9097 0.0761719 70Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4CE14",
    fillRule: "evenodd",
    d: "M2.4579 91.6086C2.23103 90.846 2.66529 90.0439 3.42783 89.8171L20.2725 84.8056C21.0351 84.5787 21.8372 85.013 22.064 85.7755C22.2909 86.5381 21.8566 87.3402 21.0941 87.567L4.24939 92.5785C3.48684 92.8054 2.68476 92.3711 2.4579 91.6086Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4CE14",
    fillRule: "evenodd",
    d: "M2.15589 48.3219C1.92903 49.0844 2.36328 49.8865 3.12583 50.1134L19.9705 55.1248C20.7331 55.3517 21.5352 54.9174 21.762 54.1549C21.9889 53.3923 21.5546 52.5903 20.7921 52.3634L3.94738 47.3519C3.18484 47.1251 2.38276 47.5593 2.15589 48.3219Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4CE14",
    fillRule: "evenodd",
    d: "M206.122 70C206.122 69.0904 205.473 68.353 204.672 68.353H186.983C186.183 68.353 185.534 69.0904 185.534 70C185.534 70.9097 186.183 71.6471 186.983 71.6471H204.672C205.473 71.6471 206.122 70.9097 206.122 70Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4CE14",
    fillRule: "evenodd",
    d: "M203.74 91.6086C203.967 90.846 203.533 90.0439 202.77 89.8171L185.925 84.8056C185.163 84.5787 184.361 85.013 184.134 85.7755C183.907 86.5381 184.341 87.3402 185.104 87.567L201.949 92.5785C202.711 92.8054 203.513 92.3711 203.74 91.6086Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4CE14",
    fillRule: "evenodd",
    d: "M204.042 48.3219C204.269 49.0844 203.835 49.8865 203.072 50.1134L186.228 55.1248C185.465 55.3517 184.663 54.9174 184.436 54.1549C184.209 53.3923 184.644 52.5903 185.406 52.3634L202.251 47.3519C203.013 47.1251 203.815 47.5593 204.042 48.3219Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.2eb4d1281c04ed1ca5e35ab411283f86.svg";
export { ForwardRef as ReactComponent };